export const APP_OFFER_IS_BETA_MESSAGE: string = 'This application is a pre-release. We will not be offering any chat support for this application at this time.';
